import { Navigate } from 'react-router-dom';
import { useSession } from 'auth/AuthProvider';

const RoleBasedRedirect: React.FC = () => {
    const session = useSession();
    if (!session) {
        return <Navigate to="/signin" replace />;
    }
    
    // Check if user has empty or no name - redirect to form-new-teacher
    if (!session.visible_name || session.visible_name.trim() === '') {
        return <Navigate to="/form-new-teacher" replace />;
    }
    
    const isManager = session.role === 'manager';
    const isTeacher = session.role === 'teacher';
    

    if (isManager) {
        return <Navigate to="/organization-reports" replace />;
    }
    
    if (isTeacher) {
        return <Navigate to="/classes" replace />;
    }

    // Default fallback if user type is unknown
    return <Navigate to="/classes" replace />;
};

export default RoleBasedRedirect;